export default __webpack_public_path__ + "static/media/output.57a81b07.wav";